import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { BrandingSettingsTypes, ErrorResponse } from "types";

const useSetBrandingAlignmentSettingsAgentOfficeMutation = (
	companyId: string,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({ settings }: { settings: BrandingSettingsTypes }) => {
			return brandingService.setBrandingAlignmentSettingsAgentOffice({
				companyId,
				settings: {
					logo_alignment: settings.logoAlignment,
					text_alignment: settings.textAlignment,
				},
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetBrandingAlignmentSettingsAgentOfficeMutation;
